<template>
<div class="enjoy-chat">
  <h1>温馨提示</h1>
  <div class="c">
    <p>尊敬的用户，为了全面提升享聊体验，享聊功能已迁移至桌面端，请点击下方按钮下载使用。</p>
  </div>
  <div class="download">
    <a @click.prevent="download">
      <img src="./assets/alpha.png">
      <span>下载 Alpha 桌面端</span>
    </a>
  </div>
</div>
</template>

<script>
import LineThrough from '@/components/line-through'

export default {
  name: 'enjoy-chat',
  components: {
    LineThrough
  },
  methods: {
    download () {
      var isMac = navigator.userAgent.toLowerCase().indexOf('mac') >= 0
      var key = isMac ? '38C54278BA5211E794A4446A2ED9E475' : '24BE5BE7BA5311E78479446A2ED9DCBD'
      this.$http.get(`/ilaw/api/v2/documents/shareLinks/public/validate/${key}`).then(result => {
        if (result.ok && result.body.resultCode === '1' && result.body.shareLinkToken) {
          this.fetchShareLink(result.body.shareLinkToken)
        }
      })
    },
    fetchShareLink (shareLinkToken) {
      this.$http.get(`/ilaw/api/v2/documents/shareLinks/public/${shareLinkToken}`).then(result => {
        if (result.ok && result.body.resultCode === '1') {
          this.fetchDownloadLink(result.body, shareLinkToken)
        }
      })
    },
    fetchDownloadLink (data, shareLinkToken) {
      this.$http.get(`/ilaw/api/v2/documents/shareLinks/public/${shareLinkToken}/downloadLink?path=${encodeURIComponent(data.path)}&downType=file`).then(result => {
        if (result.ok && result.body.succeed && result.body.result) {
          location.href = result.body.result
        }
      })
    }
  }
}

</script>

<style lang="stylus">
@import "../../styl/constant.styl"
@import "../../styl/reset.styl"
@import "../../styl/animation.styl"

.enjoy-chat
  width 540px
  margin 100px auto
  border-radius 5px
  background #fff
  box-shadow 0 4px 9px 0 rgba(0, 0, 0, 0.1)
  border 1px solid #e5e5e5
  padding 40px 30px 30px 20px
  position relative
  &:after
    position absolute
    content ""
    left 20px
    right 20px
    top 50px
    height 1px
    background lightBorder
  h1
    font-size 16px
    text-align center
    font-weight 500
    position relative
    z-index 2
    background #fff
    width 120px
    margin 0 auto
  .c
    margin 30px 50px
    p
      font-size 14px
      color blackText
  .download
    text-align center
    a
      color grayText
      &:hover
        color alphaColor
    img
      width 88px
      height 88px
    span
      display block
      font-size 14px
</style>



// WEBPACK FOOTER //
// app.vue?1d786325